module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Baxter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Stephen Baxter is an acclaimed, multiple-award-winning author whose many books include the Xeelee Sequence series, the Time Odyssey trilogy (written with Arthur C. Clarke), and "), _c('I', [_vm._v("The Time Ships")]), _vm._v(", a sequel to H. G. Wells's classic "), _c('I', [_vm._v("The Time Machine")]), _vm._v(". He lives in England.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DjJ8lv/tc-custom/9780061807220.jpg?1730581087039",
      "alt": "This image is the cover for the book Vacuum Diagrams, The Xeelee Sequence"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Vacuum Diagrams, The Xeelee Sequence\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The Philip K. Dick Award-winning saga of humankind’s next five million years: “Mind-stretching science fiction at its boldest.” —"), _c('i', [_vm._v("Orlando Sentinel")])]), _c('br'), _c('br'), _c('i', [_vm._v("And everywhere the Humans went, they found life . . . ")]), _c('br'), _c('br'), _vm._v("This dazzling future history, the most ambitious and exciting since Asimov’s classic Foundation saga, tells the story of Humankind—all the way to the end of the Universe itself. Here, in luminous and vivid narratives spanning five million years, are the first Poole wormholes spanning the solar system; the conquest of Human planets by Squeem; GUTships that outrace light; the back-time invasion of the Qax: the mystery and legacy of the Xeelee, and their artifacts as large as small galaxies; photino birds and Dark Matter; and the Ring, where Ghost, Human, and Xeelee contemplate the awesome end of Time."), _c('br'), _c('br'), _vm._v("“It’s old-fashioned 1950s-style science fiction . . . and it’s also lots of fun.” —"), _c('i', [_vm._v("Cleveland Plain Dealer")]), _c('br'), _c('br'), _vm._v("“Enormously impressive.” —"), _c('i', [_vm._v("Locus")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0